
export default function convertDate(date){
    //Converti un objet Date au format jj/mm/aaaa ou renvoie un string vide si la valeur de départ est non définie
    if(!date){
        return "";
    } else {
        let day = date.getDate().toString();
        if(day.length === 1) day="0"+day;
        let month = (date.getMonth()+1).toString();
        if(month.length===1) month="0"+month;
        const year = date.getFullYear().toString();
        return day + "/" + month + "/" + year;
    }
}